export const environment = {
  production: true,
  apiUrl: 'https://pwaapi.happyground-152857c3.eastus.azurecontainerapps.io/api',
  googleClientId: '922583087060-9k261g0ph1q4o9ljua1ecpgnj0t0kc7f.apps.googleusercontent.com',
};
